import { KeyFrameMetadataEntry } from '../autogenerated/ZoomBridge';
import HashMap from './HashMap';
import { toSMPTE } from '../util/VideoUtil';

export default class DataTimeline {
  id: number;
  name: string;
  color: string;
  frameRate: number;
  entries: KeyFrameMetadataEntry[];
  static id = -1;

  constructor(
    startTime: number = 1000,
    endTime: number = 1000,
    frameRate: number = 0,
    id: number = null,
    name: string = '',
    color: string = '',
    entries: ?(KeyFrameMetadataEntry[])
  ) {
    this.id = id;
    this.name = name;
    this.color = color;
    this.frameRate = frameRate;

    if (entries) {
      this.entries = entries;
    } else {
      this.entries = [];
      this.addEntry(startTime, endTime);
    }
  }

  addEntry(startTime: number, endTime: number) {
    const entry = new KeyFrameMetadataEntry()
      .setId(DataTimeline.id)
      .setStartTime(startTime)
      .setEndTime(endTime)
      .setMetadataMap(new HashMap());
    this.entries.push(entry);
    DataTimeline.id--;
  }
}
